import React, { Component } from 'react'
import Register from './Register'
import RegisterConfirmationPage from './RegisterConfirmationPage'
import ErrorMessagePage from '../shared/errorMessagePage/ErrorMessagePage'
import PropTypes from 'prop-types'
import RegisterAPI from '../api/RegisterAPI'

export default class RegisterUI extends Component {
    state = {
        email: '',
        showRegister:true,
        showErrorMessage:false,
        email: '',
        confirmEmail: '',
        firstName: '',
        lastName: '',
        mobilePhoneNumber: '',
        acceptTermsAndConditions: false,
        password:'',
        passwordConfirmation:'',
        loading:false,
    }

    showConfirmation = () => {
        this.setState( { showRegister: false,showErrorMessage: false } )
    }

    showErrorMessage = () => {
        this.setState( { showErrorMessage: true, showRegister: false } )
    }
    
    get getRegisterAPIUrl() {
        return process.env.REACT_APP_REGISTER_API
    }
    retrySubmitEvent = () =>{
        const { email, confirmEmail, mobilePhoneNumber, password, passwordConfirmation, firstName, lastName, acceptTermsAndConditions } = this.state

        this.setState( { loading : true } )
        RegisterAPI( {
            apiUrl: this.getRegisterAPIUrl,
            email: email,
            confirmEmail: confirmEmail,
            mobilePhoneNumber: mobilePhoneNumber,
            password: password,
            confirmPassword: passwordConfirmation,
            firstName: firstName,
            lastName: lastName,
            acceptTerms:acceptTermsAndConditions
        } )
        .then( data => { 
            this.setState( { loading : false } )  
            if( !data ){
                this.showErrorMessage()
            }else{
                this.showConfirmation()
            }
            window.scrollTo( 0, 0 )
        } )
        .catch( e => {
            this.setState( { loading : false } )  
        } )
    }
    handleSubmit = ( email, confirmEmail, mobilePhoneNumber, password, passwordConfirmation, firstName, lastName, acceptTermsAndConditions ) => {
        this.setState( { email, confirmEmail, mobilePhoneNumber, password, passwordConfirmation, firstName, lastName, acceptTermsAndConditions } )
        return RegisterAPI( {
            apiUrl: this.getRegisterAPIUrl,
            email: email,
            confirmEmail: confirmEmail,
            mobilePhoneNumber: mobilePhoneNumber,
            password: password,
            confirmPassword: passwordConfirmation,
            firstName: firstName,
            lastName: lastName,
            acceptTerms:acceptTermsAndConditions
        } )
    }
    render() {
        const { showRegister, showErrorMessage, loading } = this.state
        return (
            <>
                { showRegister
                    ? <Register handleSubmit = { this.handleSubmit } showConfirmation={ this.showConfirmation } showErrorMessage={ this.showErrorMessage } disablePhoneNumber = { this.props.config.disablePhoneNumber } />
                    : showErrorMessage 
                    ? <ErrorMessagePage retrySubmitEvent = { this.retrySubmitEvent } loading = { loading } />
                    : <RegisterConfirmationPage />
                }
            </>
        )
    }
}

RegisterUI.propTypes = {
    config: PropTypes.shape( {
        disablePhoneNumber: PropTypes.bool
    } )
}